export default "__VITE_ASSET__BSKxk_Cb__"